"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: fixed;\n  top: ", ";\n  left: auto;\n  right: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  z-index: 1000;\n\n  background: ", ";\n  box-shadow: ", ";\n  height: ", ";\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DetailBar = _styledComponents["default"].header(_templateObject(), function (props) {
  return props.second ? props.contentHeight ? 'initial' : '64px' : 0;
}, function (props) {
  return props.theme.palette.white.main;
}, function (props) {
  return "1px 5px 12px 0 ".concat(props.theme.palette.black.lightest);
}, function (props) {
  return props.contentHeight ? 'initial' : '64px';
});

var _default = (0, _react.memo)(function (props) {
  var _useContext = (0, _react.useContext)(_wrapperContext["default"]),
      incrementAmountOfDetailBars = _useContext.incrementAmountOfDetailBars;

  (0, _react.useEffect)(function () {
    return incrementAmountOfDetailBars();
  }, [incrementAmountOfDetailBars]);
  return /*#__PURE__*/_react["default"].createElement(DetailBar, props);
});

exports["default"] = _default;